module.exports = __webpack_public_path__ + "img/border.b357e46c.gif";